import React from 'react';
import IconFavouriteSelected from '../svg/IconFavouriteSelected';
import IconFavouriteUnselected from '../svg/IconFavouriteUnselected';
import { gridBorder } from './styles';
import Tooltip from '../Tooltip';

const favouriteCommon = {
    cursor: 'pointer'
};
const unfavourite = {
    ...favouriteCommon,
    fill: '#CCCCCC',
    stroke: '#CCCCCC'
};
const favourite = {
    ...favouriteCommon,
    fill: '#FAA800',
    stroke: '#FD9A00'
};
const FavouriteDataCell = ({
    rowIndex,
    colIndex,
    actionCount,
    data,
    onFavouriteClick,
    isSticky,
    scrollPxH,
    scrollPxV,
    onHover,
    isHighlighted,
    actionIconSize,
    rowHeight,
    deleteRowSelected,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false
}) => {
    const cell = {
        ...gridBorder,
        width: 48,
        minWidth: 48,
        maxWidth: 48,
        height: rowHeight,
        padding: 0,
        textAlign: 'center',
        bottom: scrollPxV,
        boxSizing: 'border-box',
        backgroundColor: isHighlighted
            ? '#dcffff'
            : deleteRowSelected
            ? '#FDF1D6'
            : rowIndex % 2 === 0
            ? '#f7f7f7'
            : '#ffffff',
        ...(isSticky
            ? {
                  zIndex: 100 + (actionCount - colIndex) - rowIndex
              }
            : {
                  right: scrollPxH
              })
    };

    const hoverEvents = {};
    if (typeof onHover === 'function') {
        hoverEvents.onMouseOver = () => onHover(rowIndex);
        hoverEvents.onMouseLeave = () => onHover(-1);
    }

    const highlightClick = () => {
        if (highlightOnClick) {
            setHighlightedIdx(rowIndex);
        }
    };

    return (
        <td
            onClick={highlightClick}
            style={{
                ...cell,
                backgroundColor:
                    rowIndex === highlightedIdx
                        ? '#dcffff'
                        : rowIndex % 2 === 0
                        ? '#f7f7f7'
                        : '#ffffff'
            }}
            {...hoverEvents}
        >
            {data.isFavourite && (
                <Tooltip text='Favourite' marginTopAdjustment={-6}>
                    <IconFavouriteSelected
                        id={`favourite${rowIndex}`}
                        style={favourite}
                        size={actionIconSize + 5}
                        onClick={() => onFavouriteClick(data)}
                    />
                </Tooltip>
            )}
            {!data.isFavourite && (
                <Tooltip text='Favourite' marginTopAdjustment={-6}>
                    <IconFavouriteUnselected
                        id={`favourite${rowIndex}`}
                        style={unfavourite}
                        size={actionIconSize + 5}
                        onClick={() => onFavouriteClick(data)}
                    />
                </Tooltip>
            )}
        </td>
    );
};

export default FavouriteDataCell;
